export const palette = {
  light: {
    background: "#F1EEE7" /* white */,
    foreground: "#09090b" /* zinc-950 */,
    card: "#F9F8F3",
    cardForeground: "#09090b" /* zinc-950 */,
    popover: "#ffffff" /* white */,
    popoverForeground: "#09090b" /* zinc-950 */,
    primary: "#FFE37D",
    primaryForeground: "#000000",
    secondary: "#F9F8F3",
    secondaryForeground: "#18181b" /* zinc-900 */,
    muted: "#f4f4f5" /* zinc-100 */,
    mutedForeground: "#71717b" /* zinc-500 */,
    accent: "#f4f4f5" /* zinc-100 */,
    accentForeground: "#18181b" /* zinc-900 */,
    destructive: "#dc2626" /* red-600 */,
    destructiveForeground: "#fafafa" /* zinc-50 */,
    border: "#e4e4e7" /* zinc-200 */,
    input: "#e4e4e7" /* zinc-200 */,
    ring: "#9f9fa9" /* zinc-400 */,
    chartOne: "#B9D3EE",
    chartTwo: "#203E3B",
    chartThree: "#59002A",
    chartFour: "#DFD2B7",
    chartFive: "#7B8827",
    chartSix: "#C2BFAC",
    sidebar: "#59002A",
    sidebarForeground: "#000000",
    sidebarPrimary: "#18181b" /* zinc-900 */,
    sidebarPrimaryForeground: "#fafafa" /* zinc-50 */,
    sidebarAccent: "#B9D3EE",
    sidebarAccentForeground: "#18181b" /* zinc-900 */,
    sidebarBorder: "#e4e4e7" /* zinc-200 */,
    sidebarRing: "#9f9fa9" /* zinc-400 */,
  },
  dark: {
    background: "#09090b" /* zinc-950 */,
    foreground: "#fafafa" /* zinc-50 */,
    card: "#18181b" /* zinc-900 */,
    cardForeground: "#fafafa" /* zinc-50 */,
    popover: "#18181b" /* zinc-900 */,
    popoverForeground: "#fafafa" /* zinc-50 */,
    primary: "#e4e4e7" /* zinc-200 */,
    primaryForeground: "#18181b" /* zinc-900 */,
    secondary: "#27272a" /* zinc-800 */,
    secondaryForeground: "#fafafa" /* zinc-50 */,
    muted: "#27272a" /* zinc-800 */,
    mutedForeground: "#9f9fa9" /* zinc-400 */,
    accent: "#27272a" /* zinc-800 */,
    accentForeground: "#fafafa" /* zinc-50 */,
    destructive: "#ff6467" /* red-400 */,
    destructiveForeground: "#fafafa" /* zinc-50 */,
    border: "#323232" /* white 15% */,
    input: "#323232" /* white 15% */,
    ring: "#71717b" /* zinc-500 */,
    chartOne: "#1447e6",
    chartTwo: "#ff2056",
    chartThree: "#fd9a00",
    chartFour: "#ad46ff",
    chartFive: "#00bc7d",
    chartSix: "#C2BFAC",
    sidebar: "#18181b" /* zinc-900 */,
    sidebarForeground: "#fafafa" /* zinc-50 */,
    sidebarPrimary: "#1447e6",
    sidebarPrimaryForeground: "#fafafa" /* zinc-50 */,
    sidebarAccent: "#27272a" /* zinc-800 */,
    sidebarAccentForeground: "#fafafa" /* zinc-50 */,
    sidebarBorder: "#ffffff1a" /* white 10% */,
    sidebarRing: "#71717b" /* zinc-500 */,
  },
};
